<template>
    <div>
        <b-row>
            <b-col>
                <b-form @submit.prevent="save">
                    <b-card>

                        <b-form-row>
                            <b-col lg="4" sm="12" class="text-left">
                                <LgFinderPageTipoEstadoConservacao id="finderTipoEstadoConservacaoListPage"
                                    @input="handleTipoEstadoConservacao" v-model="form.tipoEstadoConservacao"
                                    :prefix="[prefix + title]">
                                </LgFinderPageTipoEstadoConservacao>



                            </b-col>

                            <b-col lg="4" sm="12" class="text-left">
                                <lg-form-input invalidFeedback="Informe o a descrição" description=""
                                    v-model="form.descricao" label="Descrição:" maxlength="200" />
                            </b-col>

                            <b-col cols="1">

                                <div class="images-container">
                                    <img :src="imgPdf" class="img" alt="icone pdf" />
                                </div>

                            </b-col>
                            <b-col cols="1">
                                <b-button class=" mr-2 my-2" size="sm" style="height: 20px" pill variant="primary"
                                    @click="showModal">
                                    <div class="btn-size-alinhamento">
                                        <b-icon icon="plus" /> &nbsp;
                                    </div>
                                </b-button>
                            </b-col>


                        </b-form-row>

                        <b-form-row>
                            <b-col lg="2" sm="12" class="text-left">
                                <lg-form-const-select label="Situação:" v-model="form.situacao"
                                    :options="form.optionsFilterSituacao" />
                            </b-col>

                        </b-form-row>
                        <b-form-row>

                            <b-col lg="4" sm="4" class="text-left">
                                <lg-finder-pessoa id="finderPessoa" @onSelect="(item) => (form.pessoa = item)"
                                    ref="finderPessoa" title="PESSOA - LISTAR">
                                </lg-finder-pessoa>
                                <lg-form-input-finder v-model="form.pessoa" fieldDescription="nome" label="Pessoa:"
                                    invalidFeedback="Responsável deve ser informada!" description="">
                                    <template #prepend>
                                        <b-button @click="$refs.finderPessoa.show()" class="btn-input-finder" pressed>
                                            <b-icon icon="search" />
                                        </b-button>
                                    </template>
                                </lg-form-input-finder>


                            </b-col>

                            <lg-form-date description="" v-model="form.dtInicial" typeDatepicker="date" label="De"
                                cols="2" />
                            <lg-form-date description="" v-model="form.dtFinal" typeDatepicker="date" label="Até"
                                cols="2" />

                            <b-col cols="4" class="text-right">
                                <b-button class="mr-1 my-1" size="sm" style="height: 30px" pill variant="primary"
                                    @click="clearForm">
                                    <div class="">
                                        <b-icon icon="eraser" /> &nbsp;Limpar
                                    </div>
                                </b-button>
                                <b-button class="mr-1 my-1" size="sm" style="height: 30px" pill variant="primary"
                                    @click="load">
                                    <div class="">
                                        <b-icon icon="search" /> &nbsp;Buscar
                                    </div>
                                </b-button>
                            </b-col>

                        </b-form-row>

                        <b-form-row class="col-12">
                            <b-table id="t-pessoas" class="col-12" responsive="sm" stacked="sm" small outlined
                                sticky-header show-empty head-variant="light" :busy="this.busy" :items="this.records"
                                :fields="itensFields">

                                <template #table-busy>
                                    <div class="text-center text-primary my-2">
                                        <b-spinner class="align-middle"></b-spinner>
                                    </div>
                                </template>


                                <template #empty>
                                    <h6 style="text-align: center">
                                        Nenhum item vinculado
                                    </h6>
                                </template>


                                <template v-slot:cell(edit)="">
                                    <b-icon class="hand-pointer" @click="editar" icon="pencil" font-scale="2" />


                                </template>

                                <template v-slot:cell(desativar)="{ item }">
                                    <b-icon class="hand-pointer" @click="atualizarSituacao(0, item.cod)"
                                        v-if="item.situacao == 1" icon="square-fill" font-scale="2"
                                        style="color: green;"></b-icon>
                                    <b-icon class="hand-pointer" @click="atualizarSituacao(1, item.cod)"
                                        v-if="item.situacao == 0" icon="square" font-scale="2"
                                        style="color: green;"></b-icon>
                                </template>


                                <template v-slot:cell(pdf)="{ item }">
                                    <img :src="imgPdf" class="img" @click="gerarLaudo(item)" alt="icone pdf"
                                        title="LAUDO DE AVALIAÇÃO DE ESTADO DE CONSERVAÇÃO" />

                                </template>


                                <template #head()="data">
                                    <h6>{{ data.label.toUpperCase() }}</h6>
                                </template>
                            </b-table>
                            <b-row style="margin-top: 12px" v-if="records && records.length > 0">
                                <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">
                                    <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Página
                                        {{ page }} de {{
                                            totalPage }} -
                                        {{ total }} registros</b-col>
                                    <b-col cols="6"
                                        style="display: flex; align-items: center; font-size: 12px">Mostrando:&nbsp;
                                        <b-form-select size="sm" v-model="perPage" @change="() => this.load()"
                                            :options="perPageOptions">
                                        </b-form-select>
                                    </b-col>
                                </b-col>
                                <b-col cols="6">
                                    <div class="d-flex justify-content-end align-items-end">
                                        <b-pagination style="margin-bottom: 10px; margin-top: 10px" v-model="page"
                                            :per-page="perPage" :total-rows="total"></b-pagination>
                                    </div>
                                </b-col>
                            </b-row>
                        </b-form-row>
                    </b-card>
                </b-form>
            </b-col>
        </b-row>
        <ModalAvaliacaoEstadoConservacaoAdicionar :id="id" v-if="mostrarModal" @fecharModal="fecharModal">
        </ModalAvaliacaoEstadoConservacaoAdicionar>
    </div>
</template>
<script>

import LgFinderPageTipoEstadoConservacao from "@/components/Finders/LgFinderPageTipoEstadoConservacao.vue"

import { geradorDePdf } from "./geradordocs/pdfs";
import ModalAvaliacaoEstadoConservacaoAdicionar from "@/core/components/Modals/ModalAvaliacaoEstadoConservacaoAdicionar.vue"
import moment from "moment";
import ResourceService from "@/core/api/ResourceService";
import LgFormInput from "@/core/components/Form/LgFormInput.vue";
import LgFormDate from "@/core/components/Form/LgFormDate.vue";
import LgFinderPessoa from "@/components/Finders/LgFinderPessoa.vue";
import LgFormConstSelect from "@/core/components/Form/LgFormConstSelect.vue";
import LgFormInputFinder from "@/core/components/Form/LgFormInputFinder.vue";
import { FormResourceMixin, ListResourceMixin } from "@/core/mixins/resource";
import PdfIcon from "@/core/assets/icons/pdf.png";
import EstadoConservacaoIBPService from "@/core/api/EstadoConservacaoIBPService";

export default {
    components: {
        LgFinderPageTipoEstadoConservacao,
        ModalAvaliacaoEstadoConservacaoAdicionar,
        LgFormInput,
        LgFormConstSelect,
        LgFormDate,
        LgFinderPessoa,
        LgFormInputFinder,

    },
    mixins: [FormResourceMixin, ListResourceMixin],
    props: {
        prefix: {
            type: String,
            default: ""
        },

        id: Number,
    },
    data() {
        return {
            title: "Avaliação de Estado de Conservação",

            mostrarModal: false,
            imgPdf: PdfIcon,
            params: {},
            perPage: 10,
            perPageOptions: [10, 25, 50, 100],

            form: {
                dtInicial: '',
                descricao: '',
                dtFinal: '',
                pessoa: '',
                situacao: "1",
                tipoestadoconservacao: '',
                optionsFilterSituacao: [
                    { key: "filterSituacao", text: "Todos", value: undefined },
                    { key: "filterSituacao", text: "Ativo", value: "1" },
                    { key: "filterSituacao", text: "Inativo", value: "0" },
                ],

            },
            itensFields: [
                {
                    key: 'data', label: 'Data de Avaliação', formatter: (data) => moment(String(data)).format("DD/MM/YYYY"),
                    thStyle: "font-size: 14px; font-weight: 400;",
                    tdStyle: "font-size: 13px",
                },
                {
                    key: 'descricao', label: 'Descrição',
                    thStyle: "font-size: 14px; font-weight: 400;",
                    tdStyle: "font-size: 13px",

                },
                {
                    key: 'repCriacao', label: 'Responsável', thStyle: "font-size: 14px; font-weight: 400;",
                    tdStyle: "font-size: 13px",
                },
                {
                    key: 'tipoEstadoConservacao.descricao', label: 'Tipo de Estado', thStyle: "font-size: 14px; font-weight: 400;",
                    tdStyle: "font-size: 13px",
                },
                {
                    key: 'edit', label: '', thStyle: "font-size: 14px; font-weight: 400;",
                    tdStyle: "font-size: 13px",
                },
                {
                    key: 'desativar', label: '', thStyle: "font-size: 14px; font-weight: 400;",
                    tdStyle: "font-size: 13px",
                },
                {
                    key: 'pdf', label: '', thStyle: "font-size: 14px; font-weight: 400;",
                    tdStyle: "font-size: 13px",
                },

            ],
        };
    },
    watch: {
        page() {
            this.load();
        },
    },
    async beforeMount() {
        this.$service = new ResourceService(`/api/estado-conservacao-ibp`);
        this.$estadoConservacaoIBPService = new EstadoConservacaoIBPService();
    },


    async mounted() {
        this.load()
    },

    methods: {
        handleTipoEstadoConservacao(tipoEstado) {
            this.form.tipoEstadoConservacao = tipoEstado;
            this.load();
        },
        async gerarLaudo(item) {

            const { data } = await this.$service.findById(item.cod)

            geradorDePdf("rlaecIBP", data, "LAUDO DE AVALIAÇÃO DE ESTADO DE CONSERVAÇÃO");
        },
        showModal() {
            this.mostrarModal = true;
        },
        fecharModal() {
            this.mostrarModal = false;
            this.load();
        },
        editar() {
            this.$notify({
                type: "danger",
                message: 'Esse registro não pode ser editado. Por favor, inclua um novo',
            });

        },
        atualizarSituacao(situacao, id) {


            this.busy = true;
            this.$estadoConservacaoIBPService.atualizarSituacao(situacao, id).then(response => {

                this.busy = false;
                this.load();
                this.$notify({
                    type: "success",
                    message: response.data,
                });
            })
        },
        async load() {

            this.params.dtInicial = null;
            this.params.dtFinal = null;
            this.params.id = this.id;
            this.params.descricao = null;
            this.params.tipoEstadoConservacao = null;
            this.params.situacao = null;


            if (
                this.form.id &&
                this.form.id != ""
            ) {

                this.params.id = this.form.id;
            }

            if (this.form.dtInicial && this.form.dtFinal) {
                this.params.dtInicial = moment(String(this.form.dtInicial)).format(
                    "DD/MM/YYYY"
                );
                this.params.dtFinal = moment(String(this.form.dtFinal)).format(
                    "DD/MM/YYYY"
                );
            }

            if (this.form.descricao) {
                this.params.descricao = this.form.descricao;
            }

            if (this.form.situacao) {
                this.params.situacao = this.form.situacao;
            }

            if (this.form.tipoEstadoConservacao) {
                this.params.tipoEstadoConservacao = this.form.tipoEstadoConservacao.id;
            }


            this.busy = true;
            await this.$loadResource({
                size: this.perPage,
                page: this.page,
                params: this.params,
            });

        },
        clearForm() {

            this.form = {
                id: this.id,
                dtInicial: '',
                descricao: '',
                dtFinal: '',
                pessoa: '',
                situacao: "1",
                tipoestadoconservacao: '',
                optionsFilterSituacao: [
                    { key: "filterSituacao", text: "Todos", value: undefined },
                    { key: "filterSituacao", text: "Ativo", value: "1" },
                    { key: "filterSituacao", text: "Inativo", value: "0" },
                ],

            };


        },
        async showPessoa() {
            await this.$refs.finderPessoa.show();
        },


    },
};
</script>
<style>
.hand-pointer {
    cursor: pointer;
}
</style>